import type { UserInfo } from '@trace/shared/types';

export const mockUsers: Record<string, { password: string; user: UserInfo }> = {
  admin: {
    password: 'Password@2026',
    user: {
      id: '1001',
      username: 'admin',
      realName: '工程北米超级管理员',
      role: 'admin',
      roleName: '超级管理员 (全局穿透)',
      avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&auto=format&fit=crop&q=80',
      email: 'admin@beimi.com',
      phone: '13800138000',
      tenantId: 'tenant_wuchang_001',
      tenantName: '黑龙江工程北米农业科技有限公司',
      dataScope: 'all',
      permissions: ['*'],
      status: 'active',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-08-26T00:00:00Z',
    },
  },
  manager: {
    password: 'Password@2026',
    user: {
      id: '1002',
      username: 'lichunshan',
      realName: '李春山 (生产厂长)',
      role: 'manager',
      roleName: '生产厂长 (示范基地)',
      avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=100&auto=format&fit=crop&q=80',
      email: 'cs.li@beimi.com',
      phone: '13804518899',
      tenantId: 'tenant_wuchang_001',
      tenantName: '五常市龙凤山水稻专业种植示范合作社',
      enterpriseId: 8001,
      enterpriseCode: 'MA.156.A1.0058',
      dataScope: 'tenant',
      permissions: [
        'dashboard',
        'land:list',
        'land:map',
        'land:certificates',
        'land:ledgers',
        'farming:records',
        'farming:pesticides',
        'farming:harvests',
        'farming:videos',
        'tracecode:stats',
        'tracecode:generate',
        'tracecode:packages',
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-08-26T00:00:00Z',
    },
  },
  oem: {
    password: 'Password@2026',
    user: {
      id: '1003',
      username: 'wangjianguo',
      realName: '王建国 (秋田满满)',
      role: 'oem',
      roleName: 'OEM代工厂商 (秋田满满)',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&auto=format&fit=crop&q=80',
      email: 'jg.wang@qiutian.com',
      phone: '13904516677',
      tenantId: 'tenant_wuchang_001',
      tenantName: '秋田满满（杭州）电子商务有限公司',
      enterpriseId: 8003,
      enterpriseCode: 'MA.156.A1.0068',
      dataScope: 'tenant',
      permissions: [
        'dashboard',
        'processing:orders',
        'processing:tasks',
        'processing:mes-tasks',
        'tracecode:packages',
        'tracecode:stats',
        'tracecode:generate',
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-08-26T00:00:00Z',
    },
  },
  engnice: {
    password: 'Password@2026',
    user: {
      id: '1005',
      username: 'engnice',
      realName: '陈总监 (英式Engnice)',
      role: 'oem',
      roleName: 'OEM代工厂商 (英式)',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80',
      email: 'engnice@beimi.com',
      phone: '13900139003',
      tenantId: 'tenant_wuchang_001',
      tenantName: '英式（Engnice）营养食品科技有限公司',
      enterpriseId: 8004,
      enterpriseCode: 'MA.156.A1.0079',
      dataScope: 'tenant',
      permissions: [
        'dashboard',
        'processing:orders',
        'processing:tasks',
        'processing:mes-tasks',
        'tracecode:packages',
        'tracecode:stats',
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-08-26T00:00:00Z',
    },
  },
};
